import { isMastheadCategoryMenu, isMastheadGalleryMenu, } from '../../utils/contentful';
import { useS4XMastheadContext } from '../S4XMastheadProvider';
export var useSubmenuItem = function (id) {
    var _a, _b, _c;
    var mastheadData = useS4XMastheadContext().mastheadData;
    if (!mastheadData) {
        throw new Error('Masthead data is not available, but is required within the FlyoutSubmenu component.');
    }
    var headerNavItems = (_c = (_b = (_a = mastheadData.fields) === null || _a === void 0 ? void 0 : _a.header) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.centerNav;
    if (!headerNavItems) {
        throw new Error('Unexpected Masthead data shape: missing navigation items.');
    }
    return headerNavItems
        .filter(function (navItem) {
        return navItem &&
            (isMastheadCategoryMenu(navItem) || isMastheadGalleryMenu(navItem));
    })
        .find(function (navItem) { var _a; return ((_a = navItem === null || navItem === void 0 ? void 0 : navItem.sys) === null || _a === void 0 ? void 0 : _a.id) === id; });
};
